<template>
  <div
    class="modal is-active"
    @click="closeModal()"
  >
    <div class="modal-background" />
    <div class="modal-content is-flex">
      <img
        v-if="!image"
        src="/images/profile.png"
        alt="Image"
      >
      <img
        v-if="image"
        :src="image"
        alt="Image"
      >
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PopUpPhoto',
    props: ['image'],
    data () {
      return {}
    },
    computed: {},
    methods: {
      closeModal () {
        this.$emit('closeModal')
      }
    }
  }
</script>